import { _ as _objectWithoutProperties, d as deepMerge } from './deep-merge-c6cfd18c.js';

const _excluded = ["baseUnit", "spacingUnit"];
function toPixel(base, value) {
  return base * value;
}
function createThemeSpacing(spacingInput) {
  const {
      baseUnit = 16,
      spacingUnit = 4
    } = spacingInput,
    other = _objectWithoutProperties(spacingInput, _excluded);
  const factor = 1;
  const multiFactor = spacingUnit / baseUnit; // 0.25 = 4

  const spacing = deepMerge({
    baseUnit,
    spacingUnit,
    xxs: toPixel(baseUnit, factor - 3 * multiFactor),
    xs: toPixel(baseUnit, factor - 2 * multiFactor),
    sm: toPixel(baseUnit, factor - 1 * multiFactor),
    md: toPixel(baseUnit, factor),
    lg: toPixel(baseUnit, factor + 1 * multiFactor),
    xlg: toPixel(baseUnit, factor + 2 * multiFactor),
    xxlg: toPixel(baseUnit, factor + 3 * multiFactor)
  }, other);
  return spacing;
}

export { createThemeSpacing };
